var _rect, _rect2, _rect3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 6,
    height: 6,
    rx: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 3.5,
    width: 6,
    height: 6,
    rx: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 14.5,
    width: 6,
    height: 6,
    rx: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5h.01M17.5 6.5h.01M6.5 17.5h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 15.5a1.5 1.5 0 0 0-1.4-.8c-.9 0-1.6.5-1.6 1.2 0 1.5 3 .7 3 2.2 0 .7-.7 1.2-1.6 1.2a1.6 1.6 0 0 1-1.4-.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPayment);
export default __webpack_public_path__ + "static/media/qr-payment.b29caba4340017e8bd8b0a317b707534.svg";
export { ForwardRef as ReactComponent };